import { ref,watch } from '@vue/composition-api'
import { ReportService } from '@/app/reports/share/report.service'
import  ReportOptions from  '@/views/reports/components/options.js'

const  {defaultFromdate,defaultTodate} =ReportOptions()
export default function StatusReportLogic() {

  const request = ref({
    page: 1,
    length: 25,
    type: 'status',
    from: defaultFromdate,
    to: defaultTodate,
    devices: [],
    contracts:[],
    owners:[]
   
  })

  const date = ref('')

  const report_data = ref(null)

  const from = ref(0)
  const to = ref(0)
  const total = ref(0)

  const errors = ref({})
  const loading = ref(false)
  const dataTableloading=ref(false)


  const getReport = () => {

    // console.log(date.value)
    // let range_date = date.value.split(' to ')
    // if (range_date.length < 2) {
    //   errors.value = {range_error: 'start date and end date is required'}
    //   return;
    // }

    // request.value.from = range_date[0]
    // request.value.to = range_date[1]

    errors.value = {}
    loading.value = true

    ReportService.getReport(request.value)
      .then(res => {
        report_data.value = res.data.data
        from.value = res.data.from
        to.value = res.data.to
        total.value = res.data.total
      })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
      .finally(() =>  loading.value = false)
  }

   
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  
  
  watch([sortBy,isSortDirDesc],()=>{
     request.value.sortBy=  isSortDirDesc.value==true? sortBy.value+',desc':sortBy.value+',asc';
     dataTableloading.value = true

    ReportService.getReport(request.value)
      .then(res => {
        report_data.value = res.data.data
        from.value = res.data.from
        to.value = res.data.to
        total.value = res.data.total
      })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
      .finally(() =>  dataTableloading.value = false)
  })
  

  const getReportForPdf = () => {
    loading.value = true
    return new Promise((r, j) => {
      ReportService.getReport({ ...Object.assign(request.value, {
        page:1
      }), length: 50000}).then(res => r(res.data.data))
        .finally(() =>  loading.value = false)
    })
  }


  return {
    getReport,getReportForPdf,
    report_data,
    total, from, to,
    request, date,
    loading,
    errors,
    isSortDirDesc,sortBy,dataTableloading

  }
}
